export default __webpack_public_path__ + "static/media/aboutUsSectionImg3.fb6c4d67.jfif";